/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconUserActive is deprecated and will be archived soon. Use IconUserActive instead.
 */

export function Experimental__IconUserActive(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path d='M12.212 10.871l-2.169-1.247a.666.666 0 01-.175-1.01l.666-.781c.499-.583.8-1.339.8-2.166v-.219c0-1.775-1.34-3.326-3.111-3.44a3.333 3.333 0 00-3.556 3.325v.333c0 .827.301 1.584.8 2.166l.666.781a.667.667 0 01-.175 1.011l-2.169 1.247A3.527 3.527 0 002 13.942V15h12v-1.058c0-1.316-.72-2.464-1.788-3.071z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M18.317 15.807l-3.254-1.87a1 1 0 01-.262-1.516l.999-1.171A4.983 4.983 0 0017 8v-.329c0-2.663-2.01-4.988-4.667-5.161A5.001 5.001 0 007 7.5V8c0 1.241.452 2.375 1.2 3.249l.999 1.171a1 1 0 01-.262 1.516l-3.254 1.87A5.293 5.293 0 003 20.413V22h18v-1.587a5.292 5.292 0 00-2.683-4.606z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M28 29v-2.028a6.763 6.763 0 00-3.427-5.885l-4.35-2.5a1.353 1.353 0 01-.355-2.051l1.774-2.08a6.737 6.737 0 001.623-4.396v-.677a6.765 6.765 0 00-7.215-6.75c-3.595.233-6.314 3.379-6.314 6.982v.445c0 1.678.611 3.214 1.623 4.396l1.774 2.08a1.353 1.353 0 01-.355 2.051l-4.35 2.5A6.758 6.758 0 005 26.972V29h23z'/>"
  }, {
    size: 48,
    svgContent: "<path d='M36.635 31.613l-6.508-3.741a2 2 0 01-.525-3.032l1.998-2.342A9.957 9.957 0 0034 16v-.658c0-5.326-4.019-9.977-9.334-10.321C18.841 4.644 14 9.257 14 15v1a9.96 9.96 0 002.399 6.499l1.998 2.342a2 2 0 01-.525 3.032l-6.508 3.741A10.581 10.581 0 006 40.825V44h36v-3.174c0-3.949-2.161-7.392-5.365-9.213z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M48.847 41.485l-8.677-4.987a2.666 2.666 0 01-.7-4.042l2.664-3.123a13.279 13.279 0 003.199-8.665v-.878c0-7.102-5.359-13.302-12.446-13.761-7.766-.503-14.221 5.647-14.221 13.305v1.333c0 3.308 1.205 6.334 3.199 8.665l2.664 3.123a2.666 2.666 0 01-.7 4.042l-8.677 4.987c-4.272 2.427-7.153 7.018-7.153 12.283V58h48v-4.232c.001-5.265-2.881-9.856-7.152-12.283z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M.422 16v-.672a4 4 0 012-3.464l3.112-1.797a1.2 1.2 0 00.322-1.808l-.487-.584c-.758-.904-1.28-1.94-1.353-3.177-.041-.696.08-1.418.2-1.775a3.97 3.97 0 01.824-1.421 4.015 4.015 0 015.92 0c.376.41.644.894.823 1.421.121.357.242 1.08.2 1.775-.073 1.238-.594 2.273-1.352 3.177l-.487.584a1.2 1.2 0 00.322 1.808l3.112 1.797a4 4 0 012 3.464V16H.422z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M2.054 22v-1.604a4 4 0 012-3.464l4.787-2.764a1.5 1.5 0 00.402-2.26l-.696-.834c-.995-1.187-1.68-2.546-1.776-4.17-.054-.913.105-1.861.264-2.33a5.21 5.21 0 011.08-1.865 5.27 5.27 0 017.77 0 5.21 5.21 0 011.08 1.865c.16.469.318 1.417.264 2.33-.097 1.624-.781 2.983-1.776 4.17l-.696.835a1.5 1.5 0 00.402 2.26l4.787 2.763a4 4 0 012 3.464V22H2.054z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconUserActive;